import React, {useState} from 'react';
import {ReportForm, schoolYears, TreeCheckboxInput} from "../../components";
import {Card, CardContent, Grid} from '@material-ui/core';
import {DateInput, ReferenceInput, required, Title} from 'react-admin';
import env from "../../env";
import moment from 'moment'
import {downloadFilePost} from "../../components/FileDownload";
import {MessageCategoryInput} from "../../components/MessageCaategory";


const BcTinNhan = ({...props}) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        category: 'BAO_BAI',
        unitIds: [],
    });
    let timeout;

    function excelReport() {
        setLoading(true)
        const data = {
            fromDate: values.fromDate,
            toDate: values.toDate,
            category: values.category,
            unitIds: values.unitIds,
        }
        downloadFilePost(`${env.reportURL}/reports/bc-tin-nhan`, 'bc-tin-nhan.xlsx', data).then(r => setLoading(false)).catch(e => setLoading(false))
    }

    function validate(val) {
        const errors = {};

        if (val.fromDate && val.toDate && (val.fromDate > val.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }

        setValues({
            ...values,
            unitIds: val.unitIds,
            fromDate: val.fromDate,
            toDate: val.toDate,
            category: val.category
        })

        return errors;
    }

    return (
        <Card>
            <Title title="resources.bc-tin-nhan.name"/>
            <CardContent>
                <ReportForm validate={validate}
                            excelReport={excelReport}
                            params={values}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={4}>
                            <DateInput source="fromDate" validate={required()} {...props}
                                       label={'resources.common.fromDate'}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <DateInput source="toDate" validate={required()} {...props}
                                       label={'resources.common.toDate'}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <MessageCategoryInput source="category"
                                                  label="resources.messages.fields.category"
                                                  validate={required()}  {...props} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <label>Danh sách lớp</label>
                        <div style={{maxHeight: '300px', overflow: 'auto'}}>
                            <ReferenceInput source="unitIds"
                                            reference="units"
                                            perPage={999}
                                            filter={{
                                                clazzWithParents: true,
                                                schoolYear: schoolYears?.length > 0 ? schoolYears[0]?.id : ''
                                            }}
                            >
                                <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                            </ReferenceInput>
                        </div>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default BcTinNhan
